<template>
    <div id="intraoralViewer" class="intraoral-viewer">
        <div id="intraoralContainer" class="intraoral-container"> </div>

        <img id="intraoralListBtn" v-if="viewMode.isLoaded" data-toggle="collapse" data-target="#intraoralListPanel"
            aria-expanded="false" title="Settings" src="images/menu_white.png"
            class="intraoral-list-btn intraoral-list-ctrl" />

        <div id="intraoralAddHint1" class="intraoral-hint intraoral-add-item">Click gingiva to add tooth point</div>
        <div id="intraoralAddHint2" class="intraoral-hint intraoral-add-item">Click last point to finish shape</div>

        <div class="intraoral-zoom-container" v-show="viewMode.isLoaded">
            <img src="images/white_plus.png" class="intraoral-zoom-btn" v-on:click="changeZoom(1)"
                title="Increase Zoom" />
            <img src="images/white_minus.png" class="intraoral-zoom-btn" v-on:click="changeZoom(-1)"
                title="Decrease Zoom" />
            <!-- <img src="images/reset.png" class="dicom-zoom-btn" v-on:click="resetZoom()" title="Reset" /> -->
        </div>

        <img v-if="viewMode.isLoaded && viewMode.isDouble"
            :src="viewMode.isUpper ? 'images/intraoral/INTRAORAL_UPPER_RED.png' : 'images/intraoral/INTRAORAL_UPPER.png'"
            class="jaw-btn upper-jaw-btn" v-on:click="switchUpper()" title="Upper Jaw" />
        <img v-if="viewMode.isLoaded && viewMode.isDouble"
            :src="viewMode.isLower ? 'images/intraoral/INTRAORAL_LOWER_RED.png' : 'images/intraoral/INTRAORAL_LOWER.png'"
            class="jaw-btn lower-jaw-btn" v-on:click="switchLower()" title="Lower Jaw" />
        <!-- <img v-if="viewMode.isDouble" :src="isFront ? 'images/intraoral/INTRAORAL_FRONT_RED.png' : 'images/intraoral/INTRAORAL_FRONT.png'"
            class="jaw-btn front-jaw-btn" v-on:click="switchFront()" title="Fron View" /> -->

        <div v-show="viewMode.isLoaded" id="intraoralColor" class="input-group mb-2 mt-1 input-group-sm">
            <!-- <div class="input-group-prepend">
                <span class="input-group-text">Teeth Color:</span>
            </div> -->
            <select v-model="teethColor" class="form-control form-control-sm intraoral-tool-select"
                @change="teethColorChanged()">
                <option v-for="option in teethColors" v-bind:value="option.value">
                    {{ option.text }}
                </option>
            </select>
        </div>

        <div id="selectedToothHint" class="intraoralHint" v-show="viewMode.isLoaded"></div>
        <div id="casePostprocessingHint" class="intraoralHint"
            v-show="viewMode.isLoaded && (viewMode.isSaving || viewMode.isPostprocessing)">
            <span v-show="viewMode.isSaving"> Case saving...</span>
            <span v-show="!viewMode.isSaving && viewMode.isPostprocessing"> Case postprocessing...</span>
            <img class="intraoral-save-img" src="images/dark-blue-spinner.gif" />
        </div>

        <div v-show="viewMode.isLoaded && !isViewMode" class="intraoral-tools">

            <img v-show="viewMode.isLoaded" class="intraoral-tool-btn num-btn" v-on:click="switchTeethNumbersClick()"
                :title="showTeethNumbers ? 'Hide teeth numbers' : 'Show teeth numbers'"
                :src="showTeethNumbers ? 'images/numbers_red.png' : 'images/numbers_white.png'" />

            <img src="images/undo_white.png" class="intraoral-tool-btn undo-btn" v-on:click="undo()" title="Undo" />
            <img src="images/redo_white.png" class="intraoral-tool-btn redo-btn" v-on:click="redo()" title="Redo" />

            <img id="intraoralRepairBtn" src="images/repair_white.png" class="intraoral-tool-btn repair-btn"
                v-on:click="repairColouring()" title="Repair Colouring" />

            <!-- <img id="intraoralSmoothBtn" src="images/border_white.png" class="intraoral-tool-btn border-btn"
                v-on:click="smoothBorder()" title="Smooth Border" />  -->

            <img v-if="!isFront" :src="viewMode.isEdit ? 'images/annotation_red.png' : 'images/annotation_white.png'"
                class="intraoral-tool-btn edit-btn" v-on:click="switchEditModeClick()" title="Edit" />
            <img :src="viewMode.isFilledTeethView ? 'images/tooth_red.png' : 'images/tooth_white.png'"
                class="intraoral-tool-btn filled-teeth-btn" v-on:click="switchFilledTeethViewClick()"
                title="Filled Teeth" />

            <img src="images/save_white.png" class="intraoral-tool-btn save-btn" v-on:click="saveOnServer()"
                title="Save" />

            <img class="intraoral-tool-btn export-btn" v-if="viewMode.allowDownloads" src="images/export_white.png"
                v-on:click="showExportDialogClick($event)" title="Export" />

            <img src="images/reset.png" class="intraoral-tool-btn reset-btn" v-on:click="reset()" title="Reset" />
            <img src="images/GlobalReset.png" class="intraoral-tool-btn global-reset-btn" v-on:click="globalReset()"
                title="Global Reset" />

        </div>

        <img v-if="viewMode.isLoaded && isClosable" src="images/cross_white.png" class="intraoral-tool-btn close-btn"
            v-on:click="close()" title="Exit Intraoral View" />
        <!--  -->
        <div v-show="viewMode.isLoaded" id="intraoralBottomPanel">
            <img title="Occlusal View" src="images/intraoral/INTRAORAL_LOWER.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 1)" />
            <img title="Occlusal Reversed" src="images/intraoral/INTRAORAL_UPPER.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 2)" />
            <img title="Front View" src="images/intraoral/INTRAORAL_FRONT.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 3)" />
            <img title="Rear View" src="images/intraoral/INTRAORAL_REAR.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 4)" id="intraoralRearBtn" />
            <img title="Left Side" src="images/intraoral/INTRAORAL_RIGHT.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 5)" />
            <img title="Right Side" src="images/intraoral/INTRAORAL_LEFT.png" class="intraoral-bottom-img"
                v-on:click="rotateToView($event, 6)" />
            <img title="Set Rotate Center" src="images/center_white.png" class="intraoral-bottom-img"
                v-on:click="setRotateCenterClick()" />
        </div>

        <!-- <img id="intraoralRotateImg" class="intraoral-tool-btn" title="Rotate" src="images/angle_icon.png"
            v-on:click="toggleRotatePanel($event)" /> -->

        <div v-show="viewMode.isLoaded" class="intraoral-slider-container-sm">
            <span class="intraoral-span-sm intraoral-opacity-span">OPACITY</span>
            <span class="intraoral-span-sm">1</span>
            <div ref="opacitySlider" class="intraoral-slider-sm"></div>
            <span class="intraoral-span-sm">0</span>
        </div>

        <div id="intraoralBottomButtons" class="intraoral-add-item">
            <button id="intraoralCancel" class="intraoral-bottom-button" v-on:click="cancelClick()">
                CANCEL
            </button>
        </div>
    </div>
</template>

<script>

import {
    updateOpacity, switchViewModes, saveIntraoralData, resetIntraoral,
    globalResetIntraoral, switchEditMode, cancelAdd, setRotateCenter,
    rotateIntraoralToView, randomColorValue, monochromeColorValue,
    greyColorValue, changeTeethColor, intraoralUndo, intraoralRedo,
    smoothSelectedToothBorder, repairIntraoralColouring,
    switchTeethNumbers, switchFilledTeethView, ioViewer
} from "./IntraoralManager";

import {
    processIntraoralZip
} from "./IntraoralLoader";

import { showExportDialog } from "@/components/reports/ReportsManager";

export default {
    name: "IntraoralViewer",
    data() {
        return {
            isClosable: true,
            isFront: false,
            isViewMode: false,
            showTeethNumbers: false,
            teethColor: 'random',
            teethColors: [
                { text: "Random Color", value: randomColorValue },
                { text: "Grey Color", value: greyColorValue, }, // 808080
                { text: "White Color", value: '#FFFFFF' },
                { text: "Monochrome", value: monochromeColorValue }
            ],
        };
    },
    props: {
        viewMode: {
            type: Object,
            required: true
        },
    },
    mounted() {
        if (vueApp.isDemo) {
            // let demoUrl = "demo/demo.zip";
            // this.fetchZip(demoUrl, (zip) => {
            //     processDemoZip(zip);
            //     this.viewMode.isLoaded = true;
            //     $(".intraoral-list-ctrl").css("display", "block");
            // });
            return;
        }

        if (vueApp.isViewMode) {
            this.viewMode.isEdit = false;
            this.isViewMode = true;
        }
        this.isClosable = !!vueApp.zipFile;
        processIntraoralZip();
        this.initControls();
    },
    methods: {
        initControls: function () {
            // this.sliderId = `${this.app.divId}_slider`;
            // $(`#${this.sliderId}`).slider("value", this.current);
            // this.$refs.opacitySlider.setAttribute("id", this.sliderId);
            $(`.intraoral-slider-sm`).slider({
                orientation: "vertical",
                min: 0,
                max: 1,
                step: 0.01,
                value: 1,
                slide: (slideEvent, ui) => {
                    updateOpacity(ui.value);
                    // console.log(slideEvent, ui);
                }
            });
        },
        changeZoom: function (factor) {
            ioViewer.controls.changeZoom(factor);
        },
        undo: function () {
            intraoralUndo();
        },
        redo: function () {
            intraoralRedo();
        },
        smoothBorder: function () {
            smoothSelectedToothBorder();
        },
        repairColouring: function () {
            repairIntraoralColouring();
        },
        saveOnServer: function () {
            let updateExportedData = false;
            swal({
                text: "Are you sure you want to save intraoral changes?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(save => {
                if (save) {
                    console.log("uploading intraoral zip...", updateExportedData);
                    this.viewMode.isSaving = true;
                    saveIntraoralData(updateExportedData);
                    //  this.viewMode.isSaving = false;
                }
            });

            var $swalCheckbox = $(
                `<div class='swal-checkbox-div' style='margin-left: 50px;'>
					<input class='swal-checkbox-cb' type='checkbox' id='swalCheckbox'/> 
					<label class='swal-checkbox-lb' for='swalCheckbox'>Update exported data</label>
				</div>`
            );
            // style='color: rgba(0, 0, 0, .64);
            $(".swal-footer").append($swalCheckbox);
            $("#swalCheckbox").change(() => {
                updateExportedData = $("#swalCheckbox").is(":checked");
            });
        },
        switchUpper: function () {
            if (!this.viewMode.isUpper) {
                this.viewMode.isUpper = true;
                this.viewMode.isLower = this.isFront = false;
                switchViewModes(this.viewMode.isUpper, this.viewMode.isLower);
            }
        },
        switchLower: function () {
            if (!this.viewMode.isLower) {
                this.viewMode.isLower = true;
                this.viewMode.isUpper = this.isFront = false;
                switchViewModes(this.viewMode.isUpper, this.viewMode.isLower);
            }
        },
        switchFront: function () {
            if (!this.isFront) {
                this.isFront = true;
                this.viewMode.isUpper = this.viewMode.isLower = this.viewMode.isEdit = false;
                switchViewModes(true, true);
            }
        },
        switchTeethNumbersClick: function () {
            this.showTeethNumbers = !this.showTeethNumbers;
            switchTeethNumbers(this.showTeethNumbers);
        },
        switchEditModeClick: function () {
            this.viewMode.isEdit = !this.viewMode.isEdit;
            switchEditMode(this.viewMode.isEdit);

            if (this.viewMode.isEdit) {
                this.viewMode.isFilledTeethView = false;
                switchFilledTeethView(this.viewMode.isFilledTeethView);
            }
        },
        switchFilledTeethViewClick: function () {
            this.viewMode.isFilledTeethView = !this.viewMode.isFilledTeethView;
            switchFilledTeethView(this.viewMode.isFilledTeethView);

            if (this.viewMode.isFilledTeethView) {
                this.viewMode.isEdit = false;
                switchEditMode(this.viewMode.isEdit);
            }
        },
        reset: function () {
            swal({
                text: "Are you sure you want to reset to saved state?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(confirm => {
                if (confirm) {
                    resetIntraoral();
                }
            });
        },
        globalReset: function () {
            swal({
                text: "Are you sure you want to reset all changes?",
                buttons: {
                    yes: { text: "Yes", value: true },
                    no: { text: "No", value: false }
                }
            }).then(confirm => {
                if (confirm) {
                    globalResetIntraoral();
                }
            });
        },
        toggleRotatePanel: function (event) {
            let isVisible = $("#intraoralBottomPanel").css("display") != "none";
            if (isVisible) {
                $("#intraoralBottomPanel").fadeOut();
            } else {
                // vueApp.leaveModes(false);
                $("#intraoralBottomPanel").slideDown();
            }
        },
        rotateToView: function (event, viewNumber) {
            rotateIntraoralToView(viewNumber, true);
        },
        teethColorChanged: function () {
            changeTeethColor(this.teethColor);
        },
        close: function () {
            vueApp.isIntraoralView = false;
            document.querySelector('#intraoralViewer').style.display = 'none';
            $(".menu3d").removeAttr("style")
            // $(".menu3d").attr("disabled", false);
            document.querySelector('#views_cont').style.display = 'flex';
            if (viewer) viewer.do_resize();
        },
        cancelClick: function () {
            switchEditMode(this.viewMode.isEdit);
            cancelAdd();
        },
        setRotateCenterClick: function () {
            setRotateCenter();
        },
        showExportDialogClick: function (event) {
            showExportDialog();
        },
    }
};
</script>

<style scoped>
.intraoral-list-btn {
    cursor: pointer;
    position: absolute;
    top: 50px;
    left: 14px;
    width: 30px;
    height: 30px;
}

.intraoralHint {
    position: absolute;
    top: 20px;
    background-color: transparent;
    color: white;
    /* font-weight: bold; */
    text-align: center;
}

#selectedToothHint {
    width: 150px;
    left: calc(50% - 106px);
}

#casePostprocessingHint {
    width: 250px;
    top: 57px;
    right: 53px;
}

.intraoral-save-img {
    display: inline;
    width: 29px;
    height: 29px;
}

#intraoralColor {
    position: absolute;
    width: 130px;
    top: 11px;
    left: 12px;
    /* right: 160px; */
}

.intraoral-tool-select {
    height: 27px;
    padding: 2px;
}

#intraoralRotateImg {
    width: 30px;
    height: 30px;
    bottom: 15px;
    left: calc(50% - 5px);
}

#intraoralBottomPanel {
    position: absolute;
    bottom: 20px;
    left: calc(50% - 125px);
}

.intraoral-bottom-img {
    width: 35px;
    height: 35px;
    margin-left: 8px;
    text-align: right;
    cursor: pointer;
    border: 1px solid #FFFFFF;
}

#intraoralRearBtn {
    padding: 5px;
}

#intraoralViewer {
    position: relative;
    width: 100%;
    height: calc(100% - 35px);
    /* z-index: 9; */
}

.intraoral-container {
    /* background: #77a7fd; */
    background: #082F5E;
    width: 100%;
    height: 100%;
}

.intraoral-hint {
    position: absolute;
    z-index: 999;
    width: 350px;
    left: calc(50% - 175px);
    top: 15px;
    text-align: center;
    color: white;
    font-family: Montserrat, sans-serif;
    background-color: transparent;
    display: none;
}

#intraoralAddHint2 {
    top: 40px;
}

#intraoralBottomButtons {
    position: absolute;
    text-align: center;
    white-space: nowrap;
    left: calc(50% - 95px);
    top: 70px;
    z-index: 9;
    display: none;
    width: 200px;
    height: 35px;
}

.intraoral-bottom-button {
    display: inline-block;
    margin-right: 10px;
    min-width: 90px;
    width: auto;
    height: 35px;
    border: 0;
    cursor: pointer;
    font-size: small;
    background-color: #4687fc;
    text-align: center;
    color: #ffffff;
}

.intraoral-tools {
    position: absolute;
    top: 15px;
    right: 50px;
    display: flex;
    align-items: stretch;
    gap: 10px;
    z-index: 99;
    /* padding: 0 0.25rem; */
}

.intraoral-tool-btn {
    cursor: pointer;
    /* position: absolute; */
    /* right: 45px; */
    width: 25px;
    height: 25px;
}

.export-btn {
    /* height: 26px; */
    width: 27px;
    margin-top: 1px;
    /* margin-left: 15px; */
}

.filled-teeth-btn {
    margin-top: 1px;
    margin-left: -1px;
}

.num-btn {
    /* cursor: pointer;
    position: absolute;
    top: 7px;
    left: 205px; */
    width: 46px;
    height: 46px;
    margin-top: -10px;
}

.undo-btn {
    width: 27px;
    height: 27px;
    border: 1px solid #FFFFFF;
}

.redo-btn {
    width: 27px;
    height: 27px;
    border: 1px solid #FFFFFF;
    margin-right: 7px
}

.border-btn {
    width: 27px;
    height: 27px;
}

.save-btn {
    width: 25px;
    height: 25px;
    margin-top: 1px;
}

.reset-btn {
    width: 26px;
    height: 26px;
    margin-left: 3px;
    margin-top: 1px;
}

.global-reset-btn {
    margin-left: -3px;
    margin-top: 2px;
    width: 24px;
    height: 24px;
}

.close-btn {
    position: absolute;
    cursor: pointer;
    top: 17px;
    right: 15px;
    width: 24px;
    height: 24px;
}

.intraoral-zoom-container {
    position: absolute;
    text-align: center;
    left: 155px;
    top: 15px;
    z-index: 99;
}

.intraoral-zoom-btn {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    /* margin-bottom: 12px; */
    color: white;
    cursor: pointer;
    /* font-size: 2rem; */
}

.jaw-btn {
    cursor: pointer;
    position: absolute;
    width: 30px;
    height: 30px;
    z-index: 99;
    border: 1px solid #FFFFFF;
}

.upper-jaw-btn {
    top: 14px;
    left: 215px;
}

.lower-jaw-btn {
    top: 14px;
    left: 250px;
}

.front-jaw-btn {
    top: 85px;
    left: 15px;
}
</style>

<style>
.intraoral-slider-container-sm {
    position: absolute;
    text-align: center;
    width: 35px;
    right: 20px;
    top: 62px;
    height: calc(100% - 180px);
    z-index: 3;
}

.intraoral-span-sm {
    color: #FFFFFF;
    display: block;
    font-size: small;
}

.intraoral-opacity-span {
    margin-left: -12px;
}

.intraoral-slider-sm {
    height: calc(100% - 7px);
    border-radius: 0;
    outline: none;
    width: 0.38rem;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: calc(50% - 0.25rem);
}

.intraoral-slider-sm .ui-slider-range {
    display: none;
}

.intraoral-slider-sm .ui-slider-handle {
    outline: none;
    border-radius: 30px;
    width: 1.4rem;
    height: 1.4rem;
    left: -.54rem;
}
</style>